import styled from "styled-components";
import { TOPBAR_H } from "../../config/layout";

export const Container = styled.div`
  min-height: 100vh;
  padding-top: ${TOPBAR_H};
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #e8f2f7;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
`;

export const Card = styled.div`
  background: #fff;
  border-radius: 14px;
  padding: 40px 40px 36px;
  width: 100%;
  max-width: 420px;
  box-shadow: 0 2px 16px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0;
`;

export const CardTitle = styled.h1`
  color: #1b3a6b;
  font-size: 1.4rem;
  font-weight: 700;
  margin: 0 0 24px;
  align-self: flex-start;
`;

export const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;
`;

export const Label = styled.label`
  font-size: 0.82rem;
  font-weight: 600;
  color: #444;
`;

export const Input = styled.input`
  padding: 10px 13px;
  border: 1.5px solid #d0dce8;
  border-radius: 8px;
  font-size: 0.9rem;
  color: #222;
  outline: none;
  background: #fff;
  width: 100%;
  box-sizing: border-box;

  &:focus { border-color: #26A9B6; }
  &::placeholder { color: #bbb; }
`;

export const SubmitButton = styled.button`
  width: 100%;
  padding: 12px;
  margin-top: 6px;
  border-radius: 8px;
  border: none;
  background: #26A9B6;
  color: #fff;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;

  &:hover { background: #1f8f9a; }
  &:disabled { opacity: 0.5; cursor: not-allowed; }
`;

export const ErrorMsg = styled.p`
  color: #e53e3e;
  font-size: 0.83rem;
  margin: 0;
`;

export const LinkText = styled.p`
  color: #888;
  font-size: 0.85rem;
  text-align: center;
  margin-top: 20px;

  a {
    color: #26A9B6;
    text-decoration: none;
    font-weight: 600;
    &:hover { text-decoration: underline; }
  }
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
`;

export const Select = styled.select`
  padding: 10px 13px;
  border: 1.5px solid #d0dce8;
  border-radius: 8px;
  font-size: 0.9rem;
  color: #222;
  outline: none;
  background: #fff;
  cursor: pointer;
  width: 100%;
  box-sizing: border-box;

  &:focus { border-color: #26A9B6; }
`;
